import type { SimulatorFontSchemaType, SimulatorSchemaType } from '@vedalib/editor/lib/brand'
import styled from 'styled-components'

import { outline } from 'components/Editor/styled/Outline'
import { font } from 'services/Branding/common.styled'
import type { ElementFontCss, ElementStyleCss } from 'services/Branding/types'

const InputFieldStyled = styled.textarea<{
  $styles: ElementStyleCss<SimulatorSchemaType>
  $font: ElementFontCss<SimulatorFontSchemaType>
  $ghost?: boolean
  $hasError?: boolean
}>`
  width: 100%;
  height: 100%;
  min-width: 50px;
  flex: 1;
  padding: 4px 8px;
  border-radius: ${({ $styles }) => $styles.textarea?.borderRadius};
  border-style: ${({ $styles, $ghost }) => ($ghost ? 'none' : $styles.textarea?.borderStyle)};
  border-color: ${({ $styles, $hasError }) =>
    $hasError ? $styles.errorTextarea?.borderColor : $styles.textarea?.borderColor};
  border-width: ${({ $styles }) => $styles.textarea?.borderWidth};
  outline: none;
  background-color: ${({ $styles, $ghost }) =>
    $ghost ? 'transparent' : $styles.textarea?.backgroundColor};
  box-shadow: ${({ $styles }) => $styles.textAreaEffects?.boxShadow};
  font: inherit;
  resize: none;

  &:hover {
    background-color: ${({ $styles, $ghost }) =>
      $ghost ? 'transparent' : $styles.hoverTextarea?.backgroundColor};
  }

  &:focus {
    background-color: ${({ $styles, $ghost }) =>
      $ghost ? 'transparent' : $styles.focusTextarea?.backgroundColor};
  }
  &::placeholder {
    ${({ $font }) => font($font.placeholder)}
  }

  ${outline}
`

export default InputFieldStyled
